import { useContext, useState } from "react";
import Cookies from 'js-cookie';
import { PopupContext } from "../../contexts/popupContext";
import Popup from 'reactjs-popup';

export const Popups = () => {
  const [open, setOpen] = useState(Cookies.get('visit') !== 'true');

  const closeModal = () => {
    setOpen(false);
    Cookies.set('visit', true, { expires: 1 });
  };

  const { data, loading } = useContext(PopupContext);
  const popup = !loading && data?.allPopup;

  if (!popup || !popup.length) return null;

  const currentPopup = popup[0];
  if (!currentPopup) return null;

  return (
    <Popup
      open={open}
      closeOnDocumentClick
      onClose={closeModal}
      position="center center"
    >
      <div>
        <CloseButton onClick={closeModal} />
        <PopupImage src={currentPopup.popupImage?.asset?.url} />
      </div>
    </Popup>
  );
};

const CloseButton = ({ onClick }) => (
  <button type="button" className="close" onClick={onClick} aria-label="Close">
    &times;
  </button>
);

const PopupImage = ({ src }) => (
  <img className="popupImage" src={src} alt="Popup" />
);
